import { IMAGE_EMPTY_AVATAR } from 'common/configuration/constants';
import { getImageUrl, resolveGraphQlMediaPath } from 'common/tools/network/url';

export type UserAvatar = {
  customization?: {
    mainAvatar?: { path?: string | null } | null;
  } | null;
};

export function resolveMainAvatarUrl(
  customizationAvatarPath: string | null | undefined
): string {
  if (customizationAvatarPath) {
    return resolveGraphQlMediaPath(customizationAvatarPath);
  }
  return getImageUrl({ src: IMAGE_EMPTY_AVATAR });
}

export function resolveUserAvatar(node: UserAvatar): string {
  return resolveMainAvatarUrl(node.customization?.mainAvatar?.path);
}
